/* eslint-disable camelcase */
type LabelCount = { i18nLabel: string; count: number };

export const getTopClaim = (item: {
  missing_items_claims: number;
  incomplete_items_claims: number;
  cooked_incorrectly_claims: number;
  dietary_requirements_not_met_claims: number;
}): LabelCount => {
  const labelCounts = [
    {
      i18nLabel: 'analytics.order_accuracy.label.missing_items',
      count: item.missing_items_claims,
    },
    {
      i18nLabel: 'analytics.order_accuracy.label.incorrect_order',
      count: item.incomplete_items_claims,
    },
    {
      i18nLabel: 'analytics.order_accuracy.label.cooked_incorrectly',
      count: item.cooked_incorrectly_claims,
    },
    {
      i18nLabel: 'analytics.order_accuracy.label.dietary_requirement_not_met',
      count: item.dietary_requirements_not_met_claims,
    },
  ];

  return labelCounts.reduce((a, b) => (a.count > b.count ? a : b));
};
